import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const SearchHitInfoBoxListingLabelsPill = styled.span`
  height: 20px;
  border: solid 1px;
  border: solid 1px ${colors.elementGrey};
  border-radius: 12px;
  padding: 4px 8px;
  color: ${colors.black};
  font-size: 12px;
  margin-right: 8px;
`;
